import React, { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import FormAvaliacaoGenetica from "./Form/FormAvaliacaoGenetica";
import AvaliacaoGeneticaService from "../../services/AvaliacaoGeneticaService";
import { actions } from "../../redux/actions";
import { Loading } from "../../components";

export default function AvaliacaoGenetica(props) {

  const dispatch = useDispatch();

  const [totalAnimais, setTotalAnimais] = useState(0);
  const [classificarPor, setClassificarPor] = useState([]);
  const [ordem, setOrdem] = useState([]);
  const [numeroPagina, setNumeroPagina] = useState([]);
  const [fazendas, setFazendas] = useState([]);
  const [racas, setRacas] = useState([]);
  const [genotipados, setGenotipados] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [caracteristicas, setCaracteristicas] = useState([]);
  const [caracteristicasDefault, setCaracteristicasDefault] = useState([]);
  const [situacoesAnimal, setSituacaoesAnimal] = useState([]);
  const [sexos, setSexos] = useState([]);
  const [centrais, setCentrais] = useState([]);
  const [variedades, setVariedades] = useState([]);
  const [tops, setTops] = useState([]);
  const [consulta] = useState({
    categoria: "",
    situacao: "",
    sexo: "",
    central: "",
    variedade: "",
    Ordem: "DESC",
    campoOrdem: "MGT",
    AnimaisPorPagina: "15",
    Page: 1,
  });
  const [result, setResult] = useState([]);
  const [estatisticasClassificacao, setEstatisticasClassificacao] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const getClassificarPor = () => {
    AvaliacaoGeneticaService.classificarPor()
      .then((response) => {
        if (response && response.length > 0) {
          setClassificarPor(response);
        }
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const getOrdem = () => {
    AvaliacaoGeneticaService.ordem()
      .then((response) => {
        if (response && response.length > 0) {
          setOrdem(response);
        }
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const getNumeroPagina = () => {
    AvaliacaoGeneticaService.numeroPagina()
      .then((response) => {
        if (response && response.length > 0) {
          setNumeroPagina(response);
        }
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const getFazendas = () => {
    AvaliacaoGeneticaService.fazendas()
      .then((response) => {
        if (response && response.length > 0) {
          setFazendas(response);
        }
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const getRacas = () => {
    AvaliacaoGeneticaService.racas()
      .then((response) => {
        if (response && response.length > 0) {
          setRacas(response);
        }
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const getGenotipados = () => {
    AvaliacaoGeneticaService.genotipados()
      .then((response) => {
        if (response && response.length > 0) {
          setGenotipados(response);
        }
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const getCategorias = () => {
    AvaliacaoGeneticaService.categorias()
      .then((response) => {
        if (response && response.length > 0) {
          setCategorias(response);
        }
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const getSituacoesAnimal = () => {
    AvaliacaoGeneticaService.situacoesAnimal()
      .then((response) => {
        if (response && response.length > 0) {
          setSituacaoesAnimal(response);
        }
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const getSexos = () => {
    AvaliacaoGeneticaService.sexos()
      .then((response) => {
        if (response && response.length > 0) {
          setSexos(response);
        }
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const getCentrais = () => {
    AvaliacaoGeneticaService.centrais()
      .then((response) => {
        if (response && response.length > 0) {
          setCentrais(response);
        }
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const getVariedades = () => {
    AvaliacaoGeneticaService.variedades()
      .then((response) => {
        if (response && response.length > 0) {
          setVariedades(response);
        }
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const getTops = () => {
    AvaliacaoGeneticaService.tops()
      .then((response) => {
        if (response && response.length > 0) {
          setTops(response);
        }
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const getCaracteristicasDefault = () => {
    setLoading(true);

    AvaliacaoGeneticaService.caracteristicasDefault()
      .then((response) => {
        if (response && response.length > 0) {
          setCaracteristicasDefault(response);
        }

        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const onRacaSelected = (raca) => {
    getCaracteristicas(raca.id);
  };

  const getCaracteristicas = (racaId) => {
    setLoading(true);

    AvaliacaoGeneticaService.caracteristicasPorRaca(racaId)
      .then((response) => {
        if (response && response.length > 0) {
          setCaracteristicas(response);
        }

        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const getDescricaoCaracteristica = (id) => {
    if (Array.isArray(caracteristicas)) {
      const caracteristica = caracteristicas.find((c) => c.id == id);
      return caracteristica ? caracteristica.caracteristicaDescricao : "";
    } else {
      return "";
    }
  };

  useEffect(() => {
    setLoading(true);
    getClassificarPor();
    getOrdem();
    getNumeroPagina();
    getFazendas();
    getRacas();
    getGenotipados();
    getCategorias();
    getSituacoesAnimal();
    getSexos();
    getCentrais();
    getVariedades();
    getTops();
    getCaracteristicasDefault();

    dispatch(actions.addNewTitle("Consulta de Avaliação Genética"));
    dispatch(actions.addNewHelpText(true));
    // eslint-disable-next-line
  }, []);

  const send = (obj) => {
    var _paginaAtual = localStorage.getItem("page_filter");

    if (_paginaAtual == 'animais-filtrados' || _paginaAtual == 'filtro') {
      setLoading(true);
      setError(false);
      console.log('Antes do object', obj);
      if (obj && Object.keys(obj).length > 0) {
        Object.keys(obj).map(function (key, index) {
          if (key !== "Page" && obj[key] !== undefined && obj[key] !== null) {
            obj[key] = obj[key].toString();
          }
          return obj;
        });
      }

      setEstatisticasClassificacao(obj)

      // O backend exige IdFazenda em toda busca (campo [Required] no DTO,
      // validado pelo ASP.NET Core antes de qualquer logica rodar - nao tem
      // como contornar so mudando o que mandamos daqui). Quando o usuario
      // nao escolhe uma fazenda (uso comum: "quero os animais TOP 0.1% de
      // MGT da raça Nelore", sem se importar de qual fazenda), buscamos em
      // todas as fazendas dele em paralelo e juntamos os resultados aqui -
      // ver AvaliacaoGeneticaService.animaisFiltradosTodasFazendas.
      if (!obj || !obj.idFazenda) {
        AvaliacaoGeneticaService.animaisFiltradosTodasFazendas(fazendas, obj)
          .then((todos) => {
            localStorage.setItem("campo_ordem", obj.campoOrdem);
            localStorage.setItem("opcoes_filtro", [
              getDescricaoCaracteristica(obj.opcoesUm),
              getDescricaoCaracteristica(obj.opcoesDois),
              getDescricaoCaracteristica(obj.opcoesTres),
              getDescricaoCaracteristica(obj.opcoesQuatro),
            ]);

            setTotalAnimais(todos.length);

            const porPagina = parseInt(obj.AnimaisPorPagina) || 15;
            const pagina = parseInt(obj.Page) || 1;
            const inicio = (pagina - 1) * porPagina;
            const resultadoPagina = todos.slice(inicio, inicio + porPagina);

            if (todos.length > 0) {
              setResult(resultadoPagina);
              dispatch(actions.addNewPageFilter("animais-filtrados"));
            } else {
              setResult([]);
              setError("Nenhum animal encontrado em nenhuma das suas fazendas com esses filtros.");
            }
            setLoading(false);
          })
          .catch((error) => {
            setError(error);
            setLoading(false);
          });
        return;
      }

      AvaliacaoGeneticaService.animaisFiltrados(obj)
        .then((response) => {
          setTotalAnimais(response.totalAnimais)
          localStorage.setItem("campo_ordem", obj.campoOrdem);

          localStorage.setItem("opcoes_filtro", [
            getDescricaoCaracteristica(obj.opcoesUm),
            getDescricaoCaracteristica(obj.opcoesDois),
            getDescricaoCaracteristica(obj.opcoesTres),
            getDescricaoCaracteristica(obj.opcoesQuatro),
          ]);

          if (response && response.data.length > 0) {
            setResult(response.data);
            dispatch(actions.addNewPageFilter("animais-filtrados"));
          }
          setLoading(false);
          setError(false);
        })
        .catch((error) => {
          setError(error);
          setLoading(false);
        });
    }
  };

  return (
    <div className="avaliacao-genetica">
      <Loading show={loading} />

      <FormAvaliacaoGenetica
        classificarPor={classificarPor}
        ordem={ordem}
        numeroPagina={numeroPagina}
        fazendas={fazendas}
        racas={racas}
        genotipados={genotipados}
        categorias={categorias}
        caracteristicas={caracteristicas}
        caracteristicasDefault={caracteristicasDefault}
        situacoesAnimal={situacoesAnimal}
        sexos={sexos}
        centrais={centrais}
        variedades={variedades}
        tops={tops}
        initialConsulta={consulta}
        onRacaSelected={onRacaSelected}
        send={send}
        error={error}
        loading={loading}
        result={result}
        totalAnimais={totalAnimais}
        estatisticasClassificacao={estatisticasClassificacao}
      />
    </div>
  );
}
